import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import MenuPage from '../MenuPage/MenuPage'
import './NavBar.css';

function IMGON(props) {
  return (
    <button className="togglebtn" >
              <img src="/img/menubtn1.png" alt="" onClick={props.onClick} />
    </button>
  )
}

function IMGOFF(props) {
  return (
    <div>
          <button className="togglebtn" >
                    <img src="/img/menubtn2.png" alt="" onClick={props.onClick} />
          </button>
          <MenuPage showLess={props.showLess} onNavigate={props.onClick} />
    </div>
  )
}

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {isToggleOn: true};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }

  render() {
    return (
      <Navbar>
            {this.state.isToggleOn ? <IMGON  onClick={this.handleClick}/> : <IMGOFF showLess={this.props.showLess} onClick={this.handleClick}/> }
      </Navbar>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js